import styled from 'styled-components'
import { rgba } from 'polished'

export const Container = styled.div`
  flex: 10%;
  width: 100%;
  padding: 0px 1.5rem;

  background: url('/images/bgProjects.svg') no-repeat;
  background-position: top center;

  @media only screen and (max-width: 1024px) {
    background-size: 190%;
  }

  * {
    font-family: 'Poppins', sans-serif;
  }

  .project-data {
    position: sticky;
    float: right;
    right: -1.5rem;
    top: 50%;
    transform: translateY(-50%);

    display: flex;
    align-items: center;
    gap: 1rem;

    user-select: none;
    z-index: 20;

    .arrow {
      width: 3rem;
      height: 3rem;

      background: ${props => rgba(props.theme.colors.background.dark, 0.6)};
      backdrop-filter: blur(5px);
      border-radius: 50%;

      display: flex;
      justify-content: center;
      align-items: center;

      cursor: pointer;
      transition: all 1s;

      &.open svg {
        transform: rotateZ(180deg);
      }
      svg {
        width: 1.6rem;
        height: 1.6rem;

        stroke: linear-gradient(
          left top,
          ${props => props.theme.colors.secondary},
          ${props => props.theme.colors.primary.normal}
        );
      }
    }
    .repo-info {
      width: 4rem;
      height: fit-content;
      padding: 1rem;

      background: ${props => rgba(props.theme.colors.background.dark, 0.6)};
      backdrop-filter: blur(5px);
      border-radius: 6px;

      display: flex;
      flex-direction: column;
      align-items: center;
      row-gap: 1.2rem;

      b {
        font-weight: 600;
        font-size: 1.4rem;

        color: ${props => rgba(props.theme.colors.text.title, 0.8)};

        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        row-gap: 0.6rem;

        svg {
          width: 1.6rem;
          height: 1.6rem;

          color: ${props => props.theme.colors.primary.normal};
        }

        &:hover {
          filter: brightness(0.5);
        }
      }
    }

    .hidden {
      width: 330px;
      height: 100%;
      flex: 1;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 1rem;

      .description,
      .topics {
        height: fit-content;

        background: ${props => rgba(props.theme.colors.background.dark, 0.8)};
        backdrop-filter: blur(5px);
        border-radius: 6px;

        p {
          margin-bottom: 1rem;

          font-family: 'Poppins', sans-serif !important;
        }
      }
      .description {
        width: 100%;
        grid-area: description;
        padding: 1.5rem;

        p {
          color: ${props => props.theme.colors.primary.normal};
        }
      }

      .topics {
        grid-area: topics;
        padding: 1.5rem;

        ul {
          display: flex;
          column-gap: 0.4rem;
          row-gap: 0.4rem;
          flex-wrap: wrap;
          li {
            text-transform: capitalize;
            display: inline-block;
            font-size: 0.8rem;
            font-weight: 500;
            line-height: 22px;

            padding: 0 0.8rem;

            background-color: ${props =>
              rgba(props.theme.colors.primary.normal, 0.1)};
            color: ${props => props.theme.colors.primary.normal};
            border: 1px solid transparent;
            border-radius: 1em;
          }
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    .project-data {
      position: fixed;
      float: none;
      right: 0.5rem;
      top: 50vh;
      margin: 0;
    }
  }

  .logo_symbol {
    --offsetWidth: 0px;
    position: fixed;
    /* width: 100%; */
    height: 80vh;

    right: calc((var(--offsetWidth) / 2) * -1);
    /* top: 50%; */
    /* transform: translateY(-50%); */
    z-index: -1;

    opacity: 0.2;
    filter: grayscale(1);

    object-fit: contain;
  }

  .template {
    position: absolute;
    height: 80vh;
    /*
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%); */
    z-index: -1;
  }

  header {
    width: 100%;
    height: fit-content;
    padding: 1rem 0;

    .back-link {
      /* width: 100%; */
      display: flex;
      align-items: center;
      column-gap: 0.6rem;

      color: ${props => props.theme.colors.secondary};
      cursor: pointer;
      text-decoration: none;

      svg {
        width: calc(0.6rem + 1vw);
        height: calc(0.6rem + 1vw);
      }
      p {
        color: ${props => props.theme.colors.secondary};

        word-break: normal;
      }
    }

    .container {
      width: 100%;
      max-width: 1120px;
      padding: 0px;

      h1 {
        width: 100%;
        max-width: 667px;
        /* min-height: 400px; */

        display: flex;
        align-items: center;
        margin: 0;

        font-size: 100px;
        font-weight: 600;
        line-height: 100px;
        letter-spacing: -1px;
      }

      .header-meta {
        margin-top: 43px;
        margin-bottom: 56px;

        display: flex;
        align-items: center;
        column-gap: 2.5rem;
        row-gap: 1.2rem;
        flex-wrap: wrap;
      }

      .author {
        margin: 0;

        .avatar {
          width: 60px;
          padding: 2px;

          background: -webkit-linear-gradient(
            left top,
            ${props => props.theme.colors.secondary},
            ${props => props.theme.colors.primary.normal}
          );
          border-radius: 2000px;

          display: inline-block;
          transition: all 0.4s ease-in-out;

          img {
            width: 100%;
            vertical-align: middle;

            border: 5px solid ${props => props.theme.colors.background.normal};
            border-radius: 2000px;
          }
        }

        .data {
          display: inline-block;

          vertical-align: middle;
          margin-left: 11px;

          .name {
            font-weight: 500;
            font-size: 15px;
            letter-spacing: 0.3px;

            background: linear-gradient(
              ${props => props.theme.colors.secondary},
              ${props => props.theme.colors.primary.normal}
            );
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          .date {
            margin-top: 10px;

            font-size: 12px;
            font-weight: 200;
            line-height: 12px;
            letter-spacing: 0.5px;

            color: ${props => props.theme.colors.text.normal};
            opacity: 0.5;
          }
        }
      }

      .header-links {
        .links-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.8rem;
        }

        a,
        a:visited {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.4rem 0.85rem;
          border-radius: 999px;
          font-size: 0.82rem;
          font-weight: 600;
          letter-spacing: 0.2px;
          color: ${props => props.theme.colors.text.white};
          background: ${props => rgba(props.theme.colors.primary.normal, 0.12)};
          border: 1px solid
            ${props => rgba(props.theme.colors.primary.normal, 0.25)};
          transition: all 0.2s ease-in-out;

          &:hover {
            border-color: ${props => props.theme.colors.secondary};
            color: ${props => props.theme.colors.secondary};
          }

          svg {
            width: 0.9rem;
            height: 0.9rem;
            color: currentColor;
          }
        }
      }

      @media only screen and (max-width: 414px) {
        padding: 10px 0;
        h1 {
          font-size: 40px;
          line-height: 45px;
          max-width: 300px;
        }
        .header-meta {
          margin-top: 20px;
          margin-bottom: 20px;
          align-items: flex-start;

          .header-links {
            width: 100%;
            .links-list {
              row-gap: 0.6rem;
            }
          }
        }
      }
      @media (min-width: 576px) {
        max-width: 540px;

        width: 100%;
        margin-right: auto;
        margin-left: auto;

        h1 {
          font-size: 50px;
          line-height: 50px;
          max-width: 400px;
        }
      }
      @media (min-width: 768px) {
        max-width: 720px;
      }
      @media (min-width: 992px) {
        max-width: 960px;

        h1 {
          font-size: 80px;
          line-height: 80px;
          max-width: 667px;
        }
      }
      @media only screen and (max-width: 1200px) {
        padding: 24px 0;
      }
      @media only screen and (max-width: 414px) {
        padding: 4px 0 0;
      }
    }

    @media only screen and (max-width: 414px) {
      padding-top: 0.4rem;
    }
  }
`

export const Main = styled.main`
  width: 100%;
  max-width: 1000px;
  margin: auto;

  /* display: grid;
  grid-template-columns: calc(100% - 330px) 330px;
  grid-template-rows: 100%;
  grid-template-areas: 'content infos'; */

  .content {
    width: 100%;

    grid-area: content;
    .title {
      color: ${props => props.theme.colors.secondary};
    }

    h1 {
      font-size: 2.2rem;
    }
  }

  .infos {
    grid-area: infos;
    width: 330px;

    display: none;

    & > div {
      position: sticky;
      top: 2%;
      right: 2%;
      width: 330px;
      z-index: 100;

      display: grid;
      grid-template-columns: 45%;
      grid-template-rows: auto 50px calc(100% - 50px);
      grid-template-areas:
        'description description'
        'info info'
        'languages topics';
      row-gap: 1rem;
      column-gap: 0.8rem;
      justify-content: space-between;

      ul {
        margin-top: 1rem;

        font-weight: 600;

        list-style: inside;
      }

      .description,
      .info,
      .languages,
      .topics {
        height: fit-content;

        background: ${props => rgba(props.theme.colors.background.dark, 0.8)};
        backdrop-filter: blur(5px);
        border-radius: 6px;
      }
      .description {
        width: 100%;
        grid-area: description;
        padding: 1.5rem;

        p {
          margin-bottom: 1rem;
          color: ${props => props.theme.colors.primary.normal};
        }
      }
      .info {
        width: 100%;
        height: 100%;
        grid-area: info;

        display: flex;
        column-gap: 0.4rem;
        justify-content: space-around;

        b {
          font-weight: 600;
          font-size: 1rem;

          display: flex;
          justify-content: center;
          align-items: center;
          column-gap: 6px;

          svg {
            width: 1rem;
            height: 1rem;

            color: ${props => props.theme.colors.primary.normal};
          }
        }
      }
      .languages {
        grid-area: languages;
        padding: 1.5rem;

        ul {
          list-style: none;
        }
      }
      .topics {
        grid-area: topics;
        padding: 1.5rem;

        ul {
          display: flex;
          column-gap: 0.4rem;
          row-gap: 0.4rem;
          flex-wrap: wrap;
          li {
            text-transform: capitalize;
            display: inline-block;
            font-size: 0.8rem;
            font-weight: 500;
            line-height: 22px;

            padding: 0 0.8rem;

            background-color: ${props =>
              rgba(props.theme.colors.primary.normal, 0.1)};
            color: ${props => props.theme.colors.primary.normal};
            border: 1px solid transparent;
            border-radius: 1em;
          }
        }
      }
    }
  }

  @media (max-width: 720px) {
    grid-template-columns: 100%;
    grid-template-rows: auto;
    grid-template-areas: 'infos' 'content';

    .content,
    .infos {
      width: 100%;
    }

    .infos {
      & > div {
        width: 100%;

        grid-template-columns: 100%;
        grid-template-rows: auto 50px auto;
        grid-template-areas:
          'description description'
          'info info'
          'topics topics'
          'languages languages';
        row-gap: 1rem;
        column-gap: 0.8rem;

        .languages {
          width: fit-content;
        }
        .topics {
          width: 100%;
          ul {
            display: flex;
            column-gap: 0.6rem;
            row-gap: 0.6rem;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
`
